export const PlaySVG = () => (
  <svg
    className="h-[45px] w-[45px] drop-shadow-[0_2px_12px_rgba(0,0,0,0.25)]"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m 18.001288,9.0012883 c 0,-4.9705601 -4.0294,-8.99999977 -8.9999991,-8.99999977 -4.9705605,0 -9.00000038,4.02943967 -9.00000038,8.99999977 0,4.9705977 4.02943988,8.9999977 9.00000038,8.9999977 4.9705991,0 8.9999991,-4.0294 8.9999991,-8.9999977 z"
      className="group-hover:fill-parlor-green-20 fill-white transition duration-500 ease-in-out"
    />
    <path
      d="M 6.4434179,5.0012882 V 13.001286 L 13.110117,9.0012883 Z"
      className="fill-parlor-green"
    />
  </svg>
);

export const PauseSVG = () => (
  <svg
    className="h-[60px] w-[60px] drop-shadow-[0_2px_12px_rgba(0,0,0,0.25)]"
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <mask
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="60"
      height="60"
    >
      <rect width="60" height="60" fill="white" />
    </mask>
    <g mask="url(#mask0_238_209)">
      <path
        d="M52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30C7.5 42.4264 17.5736 52.5 30 52.5C42.4264 52.5 52.5 42.4264 52.5 30Z"
        className="group-hover:fill-parlor-green-20 fill-white transition duration-500 ease-in-out"
      />
      <path d="M23 20H28V40H23V20Z" fill="#0E3739" />
      <path d="M33 20H38V40H33V20Z" fill="#0E3739" />
    </g>
  </svg>
);

export const DrawerOpenIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="7.5" stroke="white" />
    <circle
      cx="12"
      cy="12"
      r="7.5"
      fill="white"
      className="opacity-0 group-hover:opacity-20"
      stroke="white"
    />
    <path
      d="M9 11L12 14L15 11"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DrawerCloseIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="7.5" stroke="white" />
    <circle
      cx="12"
      cy="12"
      r="7.5"
      fill="white"
      className="opacity-0 group-hover:opacity-20"
      stroke="white"
    />
    <path
      d="M9 13L12 10L15 13"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SoundOffIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="white"
      className="opacity-0 hover:opacity-20"
    />
    <path d="M4 16V8H8L13 4V20L8 16H4Z" stroke="white" strokeLinejoin="round" />
    <path
      d="M16 9L22 15"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 9L16 15"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SoundOnIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="white"
      className="opacity-0 hover:opacity-20"
    />
    <path d="M4 16V8H8L13 4V20L8 16H4Z" stroke="white" strokeLinejoin="round" />
    <path
      d="M16 8C16.636 9.17669 17 10.5429 17 12C17 13.4571 16.636 14.8233 16 16"
      stroke="white"
      strokeLinecap="round"
    />
    <path
      d="M18 5C19.22 6.64996 20 9.17273 20 12C20 14.8273 19.22 17.35 18 19"
      stroke="white"
      strokeLinecap="round"
    />
  </svg>
);

export const CloseIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="white"
      className="opacity-0 group-hover:opacity-20"
    />
    <path
      d="M17.9999 17.9999L6 6"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 6L6 18"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
